e4.bootstrap = {
    test:{}
};

